<template>
    <div class="filter_tags for_desktop">
        <div class="tag_flex">

            <div v-for="(filter, index) in selectedFilters" :key="index" class="tag_box">
                <span v-if="filter.label !== 'sort_by'">{{ filter.value }}</span>
  
                <span v-if="!isDefaultValue(filter.value)" >
                    <!-- <SvgHeaderSvg :type="'close'"/> -->
                </span>
            </div>

        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        selectedFilters: Array,
        filters: Object 
    });

    const emit = defineEmits(['newreset']);

    const isDefaultValue = (value) => {
        const defaultValues = ['All Metals', 'All Styles', 'All Shapes', 'All Carats'];
        return defaultValues.includes(value);
    };

    // const resetFilter = (filters) => {
    //     emit('resetFilter', filters)
    // @click="resetFilter(filter)"
    // }


</script>


<style scoped>
.tag_box {
    border: 1px solid var(--green);
    background: #fff;
    border-radius: 4px;
    padding: 0 3px 3px 8px;
    margin: 0 8px 8px 0;
    cursor: pointer;
}
.filter_tags {
    background: #f5f5f5;
    min-height: 53px;
    border-radius: 8px;
    padding: 10px 10px 5px 10px;
}
.filter_tags {
    display: flex;
    align-items: center;
}

.tag_flex {
    display: flex;
    align-items: center;
}

.tag_box span {
    color: #405955;
    font-size: 14px;
    margin-right: 4px;
    text-transform: capitalize;
}
</style>
